var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.745,
    height: 19.745,
    viewBox: "0 0 19.745 19.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Close_icon",
    "data-name": "Close icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M24.418,7.093a1.148,1.148,0,0,0-1.623,0l-7.913,7.913L6.969,7.093A1.148,1.148,0,0,0,5.346,8.717l7.913,7.913L5.346,24.542a1.148,1.148,0,1,0,1.624,1.623L24.418,8.717A1.148,1.148,0,0,0,24.418,7.093Z",
    transform: "translate(-5.009 -6.757)",
    fill: "#1e2528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M55.535,55.659l-1.623,1.623L60.47,63.84a1.148,1.148,0,1,0,1.623-1.623Z",
    transform: "translate(-42.684 -44.431)",
    fill: "#1e2528"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/Close-icon.b810e0a86358d30097739c36fb905679.svg";
export { ForwardRef as ReactComponent };